{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description}}
{{/if}}

<div class="preview">
  <span class="phone-number-display"></span>
  <div class="buttons">
    <button class="btn --size-small edit">Edit</button>
    <button class="btn --size-small remove">Remove</button>
  </div>
</div>

<div class="disable-inline"><button class="edit tool-button">Select Phone Number</button></div>

<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
